import { z } from "zod";

export const driversGetPayloadSchema = z.object({
  companyUuid: z.uuid(),
});

export type DriversGetPayload = z.infer<typeof driversGetPayloadSchema>;
